<template>
  <div class="pusher">
    <div
      class="ui fixed inverted main menu"
      :class="[{'collapsed' : collapsed, 'login' : currentUser}]"
    >
      <div class="right menu">
        <div class="item">Welcome, {{currentUser.email}}</div>
        <div class="item">
          <router-link to="/Logout" class="ui primary button">Logout</router-link>
        </div>
        <div class="item">
          <!-- Home icon — routes back to the customer Account
               Dashboard from inside the admin panel. Was
               previously a bare <a href="/" target="_blank">
               which (a) opened in a new tab and (b) sent the
               user to the marketing site root rather than the
               app's account home. Using <router-link> keeps
               navigation inside the SPA. -->
          <router-link to="/account" class="ui primary button"><i class="vsm-icon fa fa-home"></i></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TopMenu",
  computed: {
    ...mapGetters({ currentUser: "currentUser" })
  },
  data() {
    return {
      collapsed: false,
    }
  }
};
</script>

<style>
</style>